import { render, staticRenderFns } from "./PartnerSelectBox.vue?vue&type=template&id=a0ce2eb6&"
import script from "./PartnerSelectBox.vue?vue&type=script&lang=ts&"
export * from "./PartnerSelectBox.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports